
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Shield } from "lucide-react";

export const Firearms = () => {
  return (
    <RegulationItem 
      value="firearms" 
      icon={Shield}
      iconColor="text-red-600"
      title="Firearms"
    >
      <ul className="space-y-2 text-tribal-neutral list-disc pl-5">
        <li>Discharging firearms is strictly prohibited.</li>
      </ul>
    </RegulationItem>
  );
};
